<template>
  <div class="main">
    <!-- <div class="logo">
        <van-image
        width="100"
        height="100"
        round
        src="https://consumer.derucci.net/static/img/logo.c8d2606c.png"
        />
        <p>正在跳转到新年集福...</p>
    </div> -->
    <div class="btn">
      <p>如未自动提示打开请点击下方按钮</p>
      <van-button type="primary" size="normal" @click="launchApp"
        >点击打开集福小程序</van-button
      >
    </div>

    <div class="footer" v-if="showFooter">Powered by 流程信息中心</div>

    <van-dialog
      v-model:show="showDialog"
      show-cancel-button
      @confirm="launchApp"
      @cancel="() => (userId = '')"
    >
      <div class="tan">
        <van-field
          v-model="userId"
          label-width="5em"
          label-align="center"
          label="工号:"
          placeholder="请输入您的工号"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { wechatpublicGeneratescheme, qywechatloginApplets } from "@/api/common";
import { getUrlParams } from "@/utils/index";

import qs from "qs";
export default {
  data() {
    return {
      userId: "",
      showFooter: true,
      showDialog: false,
    };
  },
  beforeRouteEnter: (to, from, next) => {
    const code = getUrlParams("code") || "";

    if (process.env.NODE_ENV === "development") {
      next();
      return;
    }

    if (!code) {
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd054cb5d9acc03cd&redirect_uri=${encodeURIComponent(
        process.env.VUE_APP_QYWEIXIN_REDIRECT_URL
      )}&response_type=code&scope=snsapi_base&state=state#wechat_redirect`;
      return;
    }
    next();
  },
  created() {
    const nv = navigator.userAgent;
    if (nv.includes("Windows")) {
      this.showFooter = false;
      this.$dialog.alert({ message: "请使用手机企业微信App打开！" });
      return;
    }
    this.goWeixin();
  },
  mounted() {
    document.title = "慕思新年集福";
  },
  methods: {
    goWeixin() {
      const code = getUrlParams("code") || "";
      const params = {
        code,
        appId: process.env.VUE_APP_QYWEIXIN_AGENT_ID,
        systemCode: process.env.VUE_APP_QYWEIXIN_SYSTEM_CODE,
      };
      qywechatloginApplets(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.userId = res?.data?.account;
          this.launchApp();
        } else {
          this.$dialog.alert({ message: "获取小程序链接失败！" + res.msg });
        }
      });
    },
    launchApp() {
      if (!this.userId) {
        this.showDialog = true;
        return;
      }
      const path = "pages/main/homePage";
      wechatpublicGeneratescheme({
        path,
        query: qs.stringify({ userId: this.userId }),
        appId: process.env.VUE_APP_JIFU_APPID,
        envVersion: process.env.VUE_APP_JIFU_ENV_VERSION,
      }).then((res) => {
        console.log(res);
        if (res.code == 0 && res.data) {
          location.href = res?.data;
        } else {
          this.$dialog.alert({ message: "获取小程序链接失败！" + res.msg });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.van-button--primary) {
  background-color: #e53f3f;
  border-color: #e53f3f;
  border-radius: 8px;
  color: #ffedca;
  padding: 0 50px;
}
:deep(.van-cell__value) {
  border-bottom: 1px solid #969799;
}
.tan {
  padding: 50px 30px;
}
.main {
  background: #fcbb98
    url(https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/redbg.png)
    top center no-repeat;
  background-size: 100% auto;
  min-height: 100vh;
  .logo {
    padding-top: 50px;
    text-align: center;
    p {
      font-size: 14px;
    }
  }
  .btn {
    text-align: center;
    padding-top: 500px;
    padding-bottom: 100px;

    p {
      font-size: 12px;
      color: #e04241;
    }
  }
}
.footer {
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  color: #999;
  font-size: 11px;
}

/* 横屏 */
@media screen and (orientation: landscape) {
  .footer {
    display: none;
  }
}
</style>
